<div *ngIf="multiple" class="strong">
  {{ placementInvoice.company?.regularName }}
</div>
<price-line-picker
  [inputList]="placementInvoice.priceLines"
  [showSave]="showSave"
  [savingLines]="savingLines"
  (saveLines)="saveLines.emit()"
  (output)="emitSave()"
></price-line-picker>
